import push from '../../utils/routing';

export default (spaceId, queryParams) => () => {
  const basePath = `/dashboard/${spaceId}/people/participants`;

  push({
    pathname: basePath,
    ...(queryParams ? { query: queryParams } : {}),
  });
};
